/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import React from 'react';

import {navigate} from '@dvrd/dvr-controls';

import {onLogout} from '../../util/events';

import Header from './header';

import {DASHBOARD_ROUTE} from '../../util/constants';

import {requestPageChangePermission} from '../../util/pageChanger';

interface Props {
    menuWidth: number;
}

export default function HeaderController(props: Props) {
    const {menuWidth} = props;

    function onClickLogo() {
        requestPageChangePermission(() => {
            navigate(DASHBOARD_ROUTE);
        });
    }

    function onClickLogout() {
        requestPageChangePermission(onLogout);
    }

    return <Header onClickLogo={onClickLogo} menuWidth={menuWidth} onClickLogout={onClickLogout} />;
}
